import PageContainer from 'components/PageContainer/PageContainer';
import { Box, Typography } from '@mui/material';
import { alturaContainer } from 'utils/constants';
import Logo from 'assets/logo/LogoBosch.png';

const QuienesSomos = () => {
  return (
    <PageContainer marginBottom={true}>
      <Box display="flex" gap={10} flexDirection={{ xs: 'column', lg: 'row' }} alignItems='center'>
        <Box minHeight={alturaContainer} maxWidth={{ xs: '80%', lg: '500px' }} textAlign="left" mx="auto" flex="1">
          <Typography variant="h4" pb={{ xs: 2, md: 4 }}>
            Centro Cultural H. Bosch
          </Typography>
          <Typography variant="body1" mb={2} textAlign="justify">
            H. Bosch es un espacio cultural fundado en 2011 en el vibrante barrio Palermo de Montevideo, bajo la
            Dirección General de Juan Pablo Moreno. Nuestro objetivo es ofrecer una formación técnica y artística
            integral, apoyando el desarrollo profesional de artistas en distintas disciplinas.
          </Typography>
          <Typography variant="body1" mb={2} textAlign="justify">
            Este proyecto es el resultado de años de trabajo y pasión, dando vida a un lugar donde diversas artes se
            encuentran con dos grandes metas: proporcionar una formación integral en artes escénicas y convertirse en un
            referente dentro del Circuito Off de Montevideo, con propuestas de improvisación y dramaturgia
            contemporánea.
          </Typography>
          <Typography variant="body1" mb={2} textAlign="justify">
            El espacio H. Bosch se ubica en una emblemática casona de los años 40, en Gonzalo Ramírez 1826, entre Yaro y
            Frugoni.
          </Typography>
          <Typography variant="body1" mb={2} textAlign="justify">
            Concebimos esta casona como un multi-espacio dinámico, donde clases, ensayos y espectáculos coexisten,
            creando un ambiente de constante creatividad y expresión artística.
          </Typography>
        </Box>
        <Box flex="1" overflow="hidden" width="50%" maxWidth='300px' maxHeight='300px' mx="auto">
          <img src={Logo} alt="logo teatro bosch" width="100%" />
        </Box>
      </Box>
    </PageContainer>
  );
};

export default QuienesSomos;
